import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/sama.svg';
const _hoisted_1 = {
  id: "formLogin"
};
const _hoisted_2 = {
  class: "container-fluid h-100"
};
const _hoisted_3 = {
  class: "row h-100 align-items-center justify-content-center"
};
const _hoisted_4 = {
  id: "innerForm",
  class: "col-3"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "shadowLogo",
  src: _imports_0
}, null, -1);
const _hoisted_6 = {
  class: "d-grid"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _withDirectives(_createElementVNode("input", {
    type: "text",
    class: "form-control mb-3",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.formData.email = $event),
    name: "user"
  }, null, 512), [[_vModelText, $data.formData.email]]), _withDirectives(_createElementVNode("input", {
    type: "password",
    class: "form-control mb-3",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.formData.password = $event),
    name: "password"
  }, null, 512), [[_vModelText, $data.formData.password]]), _createElementVNode("div", _hoisted_6, [_createElementVNode("button", {
    class: "btn btn-primary",
    onClick: _cache[2] || (_cache[2] = $event => $options.login())
  }, "Anmelden")])])])])]);
}